export var UfEnum;
(function (UfEnum) {
    UfEnum["AC"] = "AC";
    UfEnum["AL"] = "AL";
    UfEnum["AP"] = "AP";
    UfEnum["AM"] = "AM";
    UfEnum["BA"] = "BA";
    UfEnum["CE"] = "CE";
    UfEnum["DF"] = "DF";
    UfEnum["ES"] = "ES";
    UfEnum["GO"] = "GO";
    UfEnum["MA"] = "MA";
    UfEnum["MT"] = "MT";
    UfEnum["MS"] = "MS";
    UfEnum["MG"] = "MG";
    UfEnum["PA"] = "PA";
    UfEnum["PB"] = "PB";
    UfEnum["PR"] = "PR";
    UfEnum["PE"] = "PE";
    UfEnum["PI"] = "PI";
    UfEnum["RJ"] = "RJ";
    UfEnum["RN"] = "RN";
    UfEnum["RS"] = "RS";
    UfEnum["RO"] = "RO";
    UfEnum["RR"] = "RR";
    UfEnum["SC"] = "SC";
    UfEnum["SP"] = "SP";
    UfEnum["SE"] = "SE";
    UfEnum["TO"] = "TO";
})(UfEnum || (UfEnum = {}));
export var UfEnumOptions = {
    mapDescricao: new Map([
        [UfEnum.AC, "Acre"],
        [UfEnum.AL, "Alagoas"],
        [UfEnum.AP, "Amapá"],
        [UfEnum.AM, "Amazonas"],
        [UfEnum.BA, "Bahia"],
        [UfEnum.CE, "Ceará"],
        [UfEnum.DF, "Distrito Federal"],
        [UfEnum.ES, "Espírito Santo"],
        [UfEnum.GO, "Goiás"],
        [UfEnum.MA, "Maranhão"],
        [UfEnum.MT, "Mato Grosso"],
        [UfEnum.MS, "Mato Grosso do Sul"],
        [UfEnum.MG, "Minas Gerais"],
        [UfEnum.PA, "Pará"],
        [UfEnum.PB, "Paraíba"],
        [UfEnum.PR, "Paraná"],
        [UfEnum.PE, "Pernambuco"],
        [UfEnum.PI, "Piauí"],
        [UfEnum.RJ, "Rio de Janeiro"],
        [UfEnum.RN, "Rio Grande do Norte"],
        [UfEnum.RS, "Rio Grande do Sul"],
        [UfEnum.RO, "Rondônia"],
        [UfEnum.RR, "Roraima"],
        [UfEnum.SC, "Santa Catarina"],
        [UfEnum.SP, "São Paulo"],
        [UfEnum.SE, "Sergipe"],
        [UfEnum.TO, "Tocantins"],
    ]),
    getDescricao: function (key) {
        var _a;
        return (_a = this.mapDescricao.get(key)) !== null && _a !== void 0 ? _a : "";
    },
    getValue: function (label) {
        return this.getOptions().find(function (it) { return it.label === label; });
    },
    getOptions: function () {
        return Array.from(this.mapDescricao.entries()).map(function (_a) {
            var value = _a[0], label = _a[1];
            return ({
                label: label,
                value: value,
            });
        });
    },
};
